import { render, staticRenderFns } from "./p4SettingsView.vue?vue&type=template&id=db03be6a"
import script from "./p4SettingsView.vue?vue&type=script&lang=js"
export * from "./p4SettingsView.vue?vue&type=script&lang=js"
import style0 from "./p4SettingsView.vue?vue&type=style&index=0&id=db03be6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports